import { AbstractControl, ValidationErrors } from '@angular/forms';

export class PasswordValidator {
  static validate(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value) return null;

    const hasUpperCase = /[A-Z]/.test(value);
    const hasLowerCase = /[a-z]/.test(value);
    const hasNumber = /[0-9]/.test(value);
    const hasSpecialChar = /[#*-+,=$&!?()_]/.test(value);
    const isValidLength = value.length >= 8;

    return hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar && isValidLength
      ? null
      : { passwordInvalid: true };
  }
}
